(() => {
  const productInfo = document.querySelector('product-info');
  if (!productInfo) return;

  const sticky = document.querySelector('[id^="StickyATC-"]');
  const stickyBtn = document.querySelector('[id^="StickyATCBtn-"]');
  const stickyVariant = document.querySelector('[id^="StickyATCVariant-"]');
  const variantSelects = productInfo.querySelector('variant-selects');
  const formBtn =
    productInfo.querySelector('.product-form__submit') ||
    productInfo.querySelector('button[name="add"]') ||
    productInfo.querySelector('.product-form__buttons button');


  if (!sticky || !stickyBtn || !stickyVariant || !variantSelects || !formBtn) return;

  // --- helpers -------------------------------------------------

  const optionGroups = () =>
    [...variantSelects.querySelectorAll('.product-form__input')];

  const getGroupName = (groupEl) => {
    const legend = groupEl.querySelector('legend.form__label');
    const label = groupEl.querySelector('label.form__label');
    const raw = (legend?.textContent || label?.textContent || '').trim();
    // "Color: Charcoal" -> "Color"
    return raw.split(':')[0].trim() || 'Option';
  };

  const getGroupSelection = (groupEl) => {
    const select = groupEl.querySelector('select');
    if (select) {
      const opt = select.options[select.selectedIndex];
      return (opt?.textContent || '').trim();
    }
    const checked = groupEl.querySelector('input[type="radio"]:checked');
    if (checked) return (checked.value || '').trim();
    return '';
  };

  // Track “user intent”: pas true na een echte user change
  const touched = new Set();
  const requiredNames = () => optionGroups().map(getGroupName);

  const markTouchedFromEvent = (evt) => {
    const group = evt.target.closest('.product-form__input');
    if (!group) return;
    touched.add(getGroupName(group));
  };

  const allRequiredTouched = () => {
    const req = requiredNames();
    // als er geen opties zijn: false (maar dit snippet draait toch alleen bij > default variant)
    if (!req.length) return false;

    // we willen specifiek dat Color + Size gekozen zijn als ze bestaan
    const hasColor = req.some(n => /color/i.test(n));
    const hasSize  = req.some(n => /size/i.test(n));

    if (hasColor && ![...touched].some(n => /color/i.test(n))) return false;
    if (hasSize  && ![...touched].some(n => /size/i.test(n)))  return false;

    // als er extra opties zijn (bv. Material), dan ook aanraken vóór sticky
    return req.every(n => touched.has(n));
  };

  const getSelectedText = () => {
    const parts = optionGroups()
      .map(g => {
        const name = getGroupName(g);
        const val = getGroupSelection(g);
        if (!val) return null;
        return `${name}: ${val}`;
      })
      .filter(Boolean);

    return parts.length ? parts.join(' • ') : 'Choose options';
  };

  const setStickyActive = (active) => {
    sticky.classList.toggle('is-active', active);
    document.body.classList.toggle('has-sticky-atc', active);
    sticky.setAttribute('aria-hidden', active ? 'false' : 'true');
  };

  const update = () => {
    stickyVariant.textContent = getSelectedText();
  };

  // --- visibility logic ----------------------------------------
  // Sticky mag alleen wanneer:
  // 1) echte ATC button NIET in beeld is
  // 2) klant heeft alle opties actief gekozen (touched)
  let atcOutOfView = false;

  const recompute = () => {
    const shouldShow = atcOutOfView && allRequiredTouched();
    setStickyActive(shouldShow);
    update();
  };

  const io = new IntersectionObserver((entries) => {
    const entry = entries[0];
    // als de echte knop zichtbaar is => sticky uit
    atcOutOfView = !entry.isIntersecting;
    recompute();
  }, { threshold: 0.01 });

  io.observe(formBtn);

  // --- events ---------------------------------------------------
  // Change betekent: user heeft echt iets gekozen
  variantSelects.addEventListener('change', (e) => {
    markTouchedFromEvent(e);
    recompute();
  });

  // Initial: NIET tonen (we willen geen default “S” als gekozen)
  update();
  setStickyActive(false);

  // Sticky click:
  // - als niet alles gekozen: scroll naar variant picker
  // - anders: scroll naar echte knop en klik
  stickyBtn.addEventListener('click', () => {
    if (!allRequiredTouched()) {
      variantSelects.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    formBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => formBtn.click(), 250);
  });
})();
